/** Grymwyrd Contenuti italiano per l'hero della pagina iniziale. */
export const homeIt = {
  'home.heroEyebrow': 'Un mondo horror-fantasy vivo',
  'home.heroTitle': 'Entra nel Crepuscolo',
  'home.heroBody':
    'Grymwyrd è un mondo di orrore gotico vittoriano, dove la città sommersa dalla nebbia di Greywick cela torri in rovina, cripte signorili e rituali meglio lasciati senza nome. Forgia un eroe, solleva i veli del Cataclisma e incidi il tuo nome in un mondo che ricorda.',
  'home.heroPlayCta': 'Gioca Ora',
  'home.heroBrowseCta': 'Sfoglia Enciclopedia',
  'home.heroQuickstartPrompt': 'Non sei pronto a giocare? Scarica la Quickstart gratuita',
}
